"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelFileToJSON = exports.ModelFileFromJSONTyped = exports.ModelFileFromJSON = exports.instanceOfModelFile = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ModelFile interface.
 */
function instanceOfModelFile(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfModelFile = instanceOfModelFile;
function ModelFileFromJSON(json) {
    return ModelFileFromJSONTyped(json, false);
}
exports.ModelFileFromJSON = ModelFileFromJSON;
function ModelFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'extension': !(0, runtime_1.exists)(json, 'extension') ? undefined : json['extension'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.ModelFileFromJSONTyped = ModelFileFromJSONTyped;
function ModelFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}
exports.ModelFileToJSON = ModelFileToJSON;
